// // // import {
// // //   Badge,
// // //   Button,
// // //   Card,
// // //   Col,
// // //   Form,
// // //   Icon,
// // //   Input,
// // //   notification,
// // //   Row,
// // //   Switch,
// // //   Table,
// // //   Tooltip
// // // } from 'antd'
// // // import _ from 'lodash'
// // // import moment from 'moment'
// // // import React, { Component } from 'react'
// // // import ReactHtmlParser from 'react-html-parser'
// // // import { getPushPathWrapper } from '../../../routes'
// // // import { connect } from 'react-redux'
// // // import { FormUtils, TableComp } from 'sz-react-utils-lite'
// // // import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// // // import { DisplayDate } from '../../../components/_utils/appUtils'
// // // import Request from '../../../request'
// // // import { getAllAbstracts } from '../views/actions'
// // // import AbstractActivityList from '../views/AbstractActivityList'
// // // import AbstractFilters from './abstractPages/AbstractFilters'
// // // import SelectReceiveDateDrawer from '../views/abstractPages/SelectReceiveDateDrawer'
// //
// //
// // import { Button, Card, Form, notification } from 'antd'
// // import _ from 'lodash'
// // import React, { Component } from 'react'
// // import { connect } from 'react-redux'
// // import { TableComp } from 'sz-react-utils-lite'
// // import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// // import { DisplayDate } from '../../../components/_utils/appUtils'
// // import { getAllAbstracts } from '../views/actions'
// // import AbstractFilters from './abstractPages/AbstractFilters'
// // import SelectReceiveDateDrawer from '../views/abstractPages/SelectReceiveDateDrawer'
// // import AbstractActivityList from '../views/AbstractActivityList'
// //
// // @Form.create()
// // class ReviewedAbstracts extends Component {
// //   state = {
// //     filters: {},
// //     visibleDrawer: false,
// //     abstract: {},
// //     total: '',
// //     visibleActivityList: false
// //   }
// //
// //   constructor(props) {
// //     super(props)
// //     this.table = React.createRef()
// //   }
// //   apiRequest = params => {
// //     return new Promise(async resolve => {
// //       let { dispatch } = this.props
// //       let obj = {
// //         ...params,
// //         ...this.state.filters,
// //         status: 'Reviewed Comments' // Targeted status
// //       }
// //       let data = await dispatch(getAllAbstracts(obj))
// //       this.setState({ total: data.total })
// //       resolve(data)
// //     })
// //   }
// //
// //   reload = () => {
// //     this.table.current.reload()
// //   }
// //
// //   reloadTable = data => {
// //     this.setState({ filters: data }, () => {
// //       this.reload()
// //     })
// //   }
// //
// //   render() {
// //     const columns = [
// //       {
// //         key: 'actions',
// //         width: 150,
// //         render: (val, record) => (
// //           <React.Fragment>
// //             <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
// //               View Details
// //             </a>
// //             <Button
// //               className={'roundSmallBtn'}
// //               onClick={() =>
// //                 this.setState({ visibleActivityList: true, abstract: record })
// //               }>
// //               Abstract Activities
// //             </Button>
// //           </React.Fragment>
// //         )
// //       },
// //       {
// //         title: 'Submitted Date',
// //         key: 'createdAt',
// //         dataIndex: 'createdAt',
// //         width: 100,
// //         render: item => DisplayDate(item)
// //       },
// //       {
// //         title: 'Abstract Id',
// //         key: 'onlineAbstractId',
// //         dataIndex: 'onlineAbstractId'
// //       },
// //       {
// //         title: 'Title',
// //         key: 'titleOfAbstract',
// //         dataIndex: 'titleOfAbstract'
// //       },
// //       {
// //         title: 'Author Name',
// //         key: 'authorName',
// //         dataIndex: 'authorName'
// //       },
// //       {
// //         title: 'Action',
// //         key: 'Action',
// //         render: (item, record) => (
// //           <Button
// //             className={'roundSmallBtn'}
// //             onClick={() =>
// //               this.setState({ visibleDrawer: true, abstract: record })
// //             }>
// //             Select Receive Date
// //           </Button>
// //         )
// //       }
// //     ]
// //
// //     return (
// //       <PageHeaderWrapper title={`Reviewed Abstracts (${this.state.total})`}>
// //         <Card bordered={true}>
// //           <AbstractFilters
// //             callback={data => {
// //               this.reloadTable(data)
// //             }}
// //           />
// //           <TableComp
// //             ref={this.table}
// //             columns={columns}
// //             apiRequest={this.apiRequest}
// //           />
// //         </Card>
// //
// //         {this.state.visibleDrawer ? (
// //           <SelectReceiveDateDrawer
// //             visible={this.state.visibleDrawer}
// //             abstract={this.state.abstract}
// //             reviewerId={this.state.abstract.selectedReviewer && this.state.abstract.selectedReviewer.length > 0 ? this.state.abstract.selectedReviewer[0].reviewerId : null}
// //             callback={this.reload}
// //             onClose={() => this.setState({ visibleDrawer: false })}
// //           />
// //         ) : null}
// //
// //         {this.state.visibleActivityList ? (
// //           <AbstractActivityList
// //             abstractId={this.state.abstract._id}
// //             abstractIdNo={this.state.abstract.onlineAbstractId}
// //             visible={this.state.visibleActivityList}
// //             onClose={() => this.setState({ visibleActivityList: false })}
// //           />
// //         ) : null}
// //       </PageHeaderWrapper>
// //     )
// //   }
// // }
// //
// // export default connect()(ReviewedAbstracts)
// import { Button, Card, Form, notification } from 'antd'
// import _ from 'lodash'
// import React, { Component } from 'react'
// import { connect } from 'react-redux'
// import { TableComp } from 'sz-react-utils-lite'
// import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import { DisplayDate } from '../../../components/_utils/appUtils'
// import { getAllAbstracts } from '../views/actions'
// import AbstractFilters from './abstractPages/AbstractFilters'
// import SelectReceiveDateDrawer from '../views/abstractPages/SelectReceiveDateDrawer'
// import AbstractActivityList from '../views/AbstractActivityList'
//
// @Form.create()
// class ReviewedAbstracts extends Component {
//   state = {
//     filters: {},
//     visibleDrawer: false,
//     abstract: {},
//     total: '',
//     visibleActivityList: false
//   }
//
//   constructor(props) {
//     super(props)
//     this.table = React.createRef()
//   }
//
//   componentDidMount() {
//     // Force reload on mount
//     if (this.table.current) this.table.current.reload();
//   }
//
//   apiRequest = params => {
//     return new Promise(async resolve => {
//       let { dispatch } = this.props
//       // Matching the AllArticle structure exactly
//       let obj = {
//         ...params,
//         ...this.state.filters,
//         status: 'Reviewed Comments'
//       }
//       let regExpFilters = []
//
//       let data = await dispatch(
//         getAllAbstracts({ ...obj, regExFilters: regExpFilters })
//       )
//
//       this.setState({ total: data.total })
//       resolve(data)
//     })
//   }
//
//   reload = () => {
//     this.table.current.reload()
//   }
//
//   reloadTable = data => {
//     // Same date filter logic as AllArticle
//     if (data.fromDate && data.toDate) {
//       data['createdAt'] = {
//         $gte: data.fromDate,
//         $lte: data.toDate
//       }
//       delete data['fromDate']
//       delete data['toDate']
//     }
//     this.setState({ filters: data }, () => {
//       this.reload()
//     })
//   }
//
//   render() {
//     const { loading } = this.props
//     const columns = [
//       // {
//       //   key: 'actions',
//       //   width: 150,
//       //   render: (val, record) => (
//       //     <React.Fragment>
//       //       <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
//       //         View Details
//       //       </a>
//       //       <Button
//       //         className={'roundSmallBtn'}
//       //         onClick={() =>
//       //           this.setState({ visibleActivityList: true, abstract: record })
//       //         }>
//       //         Abstract Activities
//       //       </Button>
//       //     </React.Fragment>
//       //   )
//       // },
//       {
//         key: 'actions',
//         width: 350, // Increased width to ensure they fit in one row
//         render: (val, record) => (
//           <React.Fragment>
//             <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
//               View Details
//             </a>
//             <Button
//               className={'roundSmallBtn'}
//               onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
//               Activities
//             </Button>
//
//             {/* Buttons without type props for simple, neutral styling */}
//             <Button
//               className={'roundSmallBtn'}
//               onClick={() => { /* Add logic */ }}>
//               Comments
//             </Button>
//             <Button
//               className={'roundSmallBtn'}
//               onClick={() => { /* Add logic */ }}>
//               Reject
//             </Button>
//             <Button
//               className={'roundSmallBtn'}
//               onClick={() => { /* Add logic */ }}>
//               Approve
//             </Button>
//           </React.Fragment>
//         )
//       },
//       {
//         title: 'Submitted Date',
//         key: 'createdAt',
//         dataIndex: 'createdAt',
//         width: 100,
//         render: item => DisplayDate(item)
//       },
//       {
//         title: 'Abstract Id',
//         key: 'onlineAbstractId',
//         dataIndex: 'onlineAbstractId'
//       },
//       {
//         title: 'Title',
//         key: 'titleOfAbstract',
//         dataIndex: 'titleOfAbstract'
//       },
//       {
//         title: 'Author Name',
//         key: 'authorName',
//         dataIndex: 'authorName'
//       },
//       {
//         title: 'Action',
//         key: 'Action',
//         render: (item, record) => (
//           <Button
//             className={'roundSmallBtn'}
//             onClick={() =>
//               this.setState({ visibleDrawer: true, abstract: record })
//             }>
//             Select Receive Date
//           </Button>
//         )
//       }
//     ]
//
//     return (
//       <PageHeaderWrapper title={`Reviewed Abstracts (${this.state.total})`}>
//         <Card bordered={true}>
//           <AbstractFilters
//             callback={data => {
//               this.reloadTable(data)
//             }}
//           />
//           <TableComp
//             ref={this.table}
//             columns={columns}
//             apiRequest={this.apiRequest}
//           />
//         </Card>
//
//         {this.state.visibleDrawer ? (
//           <SelectReceiveDateDrawer
//             visible={this.state.visibleDrawer}
//             abstract={this.state.abstract}
//             reviewerId={this.state.abstract.selectedReviewer && this.state.abstract.selectedReviewer.length > 0 ? this.state.abstract.selectedReviewer[0].reviewerId : null}
//             callback={this.reload}
//             onClose={() => this.setState({ visibleDrawer: false })}
//           />
//         ) : null}
//
//         {this.state.visibleActivityList ? (
//           <AbstractActivityList
//             abstractId={this.state.abstract._id}
//             abstractIdNo={this.state.abstract.onlineAbstractId}
//             visible={this.state.visibleActivityList}
//             onClose={() => this.setState({ visibleActivityList: false })}
//           />
//         ) : null}
//       </PageHeaderWrapper>
//     )
//   }
// }
//
// const mapStateToProps = ({ global }) => ({
//   categories: global.categories
// })
// const mapDispatchToProps = dispatch => ({ dispatch })
//
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(ReviewedAbstracts)

import { Button, Card, Form, notification } from 'antd'
import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { DisplayDate } from '../../../components/_utils/appUtils'
import { getAllAbstracts } from '../views/actions'
import AbstractFilters from './abstractPages/AbstractFilters'
// import CommentsToAuthorDrawer from '../drawers/commentsToAuthorDrawer'
import AbstractActivityList from '../views/AbstractActivityList'
import CommentsToAbstractDrawer from '../views/abstractPages/AbstractCommentsDrawer'
import RejectionDrawer from '../views/abstractPages/RejectionDrawer'


@Form.create()
class ReviewedAbstracts extends Component {
  state = {
    filters: {},
    visibleDrawer: false,
    abstract: {},
    total: '',
    visibleActivityList: false,
    visibleRejectionDrawer: false,
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      // Abstract-specific status
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Reviewed Comments'
      }
      let regExpFilters = []

      let data = await dispatch(
        getAllAbstracts({ ...obj, regExFilters: regExpFilters })
      )

      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  reloadTable = data => {
    // Abstract date filtering (adjust key if your schema uses 'submittedDate' instead of 'createdAt')
    if (data.fromDate && data.toDate) {
      data['createdAt'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  render() {
    const columns = [
      // {
      //   key: 'actions',
      //   width: 150,
      //   render: (val, record) => (
      //     <React.Fragment>
      //       <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
      //         View Details
      //       </a>
      //       <Button
      //         className={'roundSmallBtn'}
      //         onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
      //         Abstract Activities
      //       </Button>
      //     </React.Fragment>
      //   )
      // },
      // {
      //   key: 'actions',
      //   width: 150,
      //   render: (val, record) => (
      //     <React.Fragment>
      //       <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
      //         View Details
      //       </a>
      //       <Button
      //         className={'roundSmallBtn'}
      //         onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
      //         Abstract Activities
      //       </Button>
      //     </React.Fragment>
      //   )
      // },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        width: 150,
        render: item => (item ? DisplayDate(item) : null)
      },
      {
        title: 'Abstract Id',
        key: 'onlineAbstractId',
        width: 150,
        dataIndex: 'onlineAbstractId'
      },
      {
        title: 'Author Name',
        key: 'authorName',
        width: 150,
        dataIndex: 'authorName'
      },
      // {
      //   title: 'Reviewer',
      //   key: 'selectedReviewer',
      //   dataIndex: 'selectedReviewer',
      //   render: item => (item && item.length > 0 ? item[0].reviewerName || item[0].reviewerId : '')
      // },
      // {
      //   title: 'Reviewer',
      //   key: 'selectedReviewer',
      //   dataIndex: 'selectedReviewer',
      //   render: item => {
      //     // Safety check: is the array valid?
      //     if (!item || !Array.isArray(item) || item.length === 0) return 'No Reviewer';
      //
      //     const reviewer = item[0];
      //
      //     // Scenario A: It's an object populated with a 'name' field
      //     if (reviewer.reviewerId && typeof reviewer.reviewerId === 'object' && reviewer.reviewerId.name) {
      //       return reviewer.reviewerId.name;
      //     }
      //
      //     // Scenario B: It's just a name string directly
      //     if (reviewer.reviewerName) {
      //       return reviewer.reviewerName;
      //     }
      //
      //     // Scenario C: It's just an ID string (Fallback)
      //     return reviewer.reviewerId || 'Pending';
      //   }
      // },
      // {
      //   title: 'Send to Reviewer',
      //   key: 'selectedReviewer',
      //   dataIndex: 'selectedReviewer',
      //   width: 100,
      //   render: item => (item && item.length > 0 ? DisplayDate(item[0].sendDate) : null)
      // },
      // {
      //   title: 'Comments Received',
      //   key: 'selectedReviewer',
      //   dataIndex: 'selectedReviewer',
      //   width: 100,
      //   render: item => (item && item.length > 0 ? DisplayDate(item[0].receiveDate) : null)
      // },
      // REPLACE your current Reviewer, Send, and Receive columns with these:
      {
        title: 'Reviewer',
        key: 'selectedReviewer',
        dataIndex: 'selectedReviewer',
        width: 150,
        render: item => (
          item && item.length > 0
            ? (item[0].reviewerName || item[0].reviewer || 'Reviewer Assigned')
            : 'Pending'
        )
      },
      {
        title: 'Send to Reviewer',
        key: 'selectedReviewer',
        dataIndex: 'selectedReviewer',
        width: 150,
        render: item => (
          item && item.length > 0 && item[0].assignedDate
            ? DisplayDate(item[0].assignedDate) // Use assignedDate instead of sendDate
            : '-'
        )
      },
      {
        title: 'Comments Date',
        key: 'receiveDate',
        dataIndex: 'selectedReviewer',
        width: 150,
        render: item => (
          item && item.length > 0 && item[0].receiveDate
            ? DisplayDate(item[0].receiveDate)
            : '-'
        )
      },
      // {
      //   title: 'Action',
      //   key: 'Action',
      //   render: (item, record) => (
      //     <Button
      //       className={'roundSmallBtn'}
      //       onClick={() => this.setState({ visibleDrawer: true, abstract: record })}>
      //       Comments to author
      //     </Button>
      //   )
      // }
      {
        title: 'Action',
        key: 'actions',
        width: 150, // Narrow width works best for a vertical stack
        render: (val, record) => (
          <div style={{
            display: 'flex',
            flexDirection: 'column', // Stacks buttons vertically
            gap: '5px',
            alignItems: 'flex-start' // Aligns buttons to the left
          }}>
            <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>
              View Details
            </a>
            <Button
              className={'roundSmallBtn'}
              onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Activities
            </Button>

            <Button
              className={'roundSmallBtn'}
              onClick={() => this.setState({ visibleDrawer: true, abstract: record })}>
              Comments
            </Button>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleRejectionDrawer: true, abstract: record })}>
              Reject
            </Button>
            <Button
              className={'roundSmallBtn'}
              onClick={() => { /* Add logic for Approve */ }}>
              Approve
            </Button>
          </div>
        )
      }    ]

    return (
      <PageHeaderWrapper title={`Reviewed Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => this.reloadTable(data)} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>

        {/*{this.state.visibleDrawer ? (*/}
        {/*  <CommentsToAuthorDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    articleId={this.state.abstract._id}*/}
        {/*    article={this.state.abstract}*/}
        {/*    callback={this.reload}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*  />*/}
        {/*) : null}*/}
        {this.state.visibleDrawer ? (
          <CommentsToAbstractDrawer
            visible={this.state.visibleDrawer}
            abstractId={this.state.abstract._id}
            abstract={this.state.abstract}
            callback={this.reload}
            onClose={() => this.setState({ visibleDrawer: false })}
          />
        ) : null}
        {this.state.visibleActivityList ? (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            abstractIdNo={this.state.abstract.onlineAbstractId}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        ) : null}
        <RejectionDrawer
          visible={this.state.visibleRejectionDrawer}
          abstractId={this.state.abstract._id}
          abstract={this.state.abstract}
          callback={this.reload}
          onClose={() => this.setState({ visibleRejectionDrawer: false })}
        />
        )}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({ categories: global.categories })
export default connect(mapStateToProps)(ReviewedAbstracts)
